/* eslint-disable import-helpers/order-imports */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { actions as communicationActions, selectors as communicationSelectors } from "store/modules/communication";
import { IconButton } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { convertUTCToTimezoneWithOffset, displayLocalDateTime, formattedTimeWithOffset } from 'utils/time';
import moment from 'moment';
import { useStyles } from '../styles';
import ReactTableSimple from 'components/ReactTable/ReactTableSimple';
import AnnouncementSubTable from '../AnnouncementSubTable';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';

export default function Table(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const announcement = useSelector(communicationSelectors.getArchiveAnnouncementsListData("data"))
    const isLoading = useSelector(communicationSelectors.getIsPageLoading)
    const { t } = useTranslation();

    useEffect(() => {
        const params = new URLSearchParams(props.history.location.search);
        const tab = parseInt(params.get("tab"), 10);
        dispatch(communicationActions.fetchAnnouncements(tab));
    }, []);

    const columns = [
        {
            Header: t("common_table_column_id"),
            id: "id",
            accessor: "id",
            Cell: ({ row: { original, isExpanded, ...row } }) => {
                return (
                    <span className={classes.expandCell}>
                        <IconButton {...row.getToggleRowExpandedProps()} style={{ padding: 3, marginLeft: -10 }}>
                            {isExpanded ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                        {original.id}
                    </span>
                )
            }
        },
        {
            Header: t("common_table_column_work_type"),
            id: "workType.label",
            accessor: i18n.language === "fr" ? "workType.frenchName" : "workType.label",
            className: "-cursor-pointer",
            Cell: ({ row: { original } }) => {
                return original.workType ? original.workType?.[i18n.language === "fr" ? "frenchName" : "label"] : ''
            }
        },
        {
            Header: t("common_table_column_start_date"),
            disableFilters: true,
            id: "startUtc",
            accessor: "startUtc",
            styles: {
                minWidth: '125px'
            },
            Cell: ({ row: { original } }) => {
                return (
                    <div>
                        {convertUTCToTimezoneWithOffset(original.startUtc, original.timezone, "MMM Do, YYYY")}
                        <br />
                        {displayLocalDateTime(original.startUtc, original.timezone, "MMM Do, YYYY")}
                    </div>
                );
            },
            sortable: false,
            className: "-cursor-pointer",
        },
        {
            Header: t("common_table_column_shift"),
            id: "Shift",
            disableFilters: true,
            disableSortBy: true,
            Cell: ({ row: { original } }) => {
                return formattedTimeWithOffset(original.startUtc, original.endUtc, original.timezone);
            },
            accessor: ({ startUtc, endUtc }) => {
                const startTime = moment(startUtc).format("h:mm a");
                const endTime = moment(endUtc).format("h:mm a");
                return `${startTime} - ${endTime}`;
            },

            className: "-cursor-pointer",
            styles: {
                minWidth: '150px'
            },
        },
        {
            Header: t("common_table_column_location"),
            id: "city",
            accessor: ({ city, region }) => `${city}, ${region}`,
            maxWidth: 200,
            className: "-cursor-pointer",
            styles: {
                minWidth: '100px'
            },
        },
    ];

    return (
        <>
            <ReactTableSimple
                classes={classes}
                columns={columns}
                hasFilter
                data={announcement}
                loading={isLoading}
                initialSort={[{ id: 'id', desc: true }]}
                expandView={(row) => {
                    return (
                        <AnnouncementSubTable data={row.original} />
                    )

                }}
            />
        </>
    )
}
